export enum PaymentCardsFlowType {
  LocationSelection,
  SelectCard,
}
